import { render, staticRenderFns } from "./SimpleVehicleView.vue?vue&type=template&id=59241639&"
import script from "./SimpleVehicleView.vue?vue&type=script&lang=js&"
export * from "./SimpleVehicleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports